module.exports = __webpack_public_path__ + "static/media/example - take waist in - tailor - enlarged without head2.4d082a67.jpg";